import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { getData, postData } from 'src/utils/axios/serverHelper';

import {
    TQC1020_R01Dto,
    TQC1020_R01DetailDto,
    TQC1020_R01HeaderDto,
} from './Dto_TQC1020_R01';

const baseUrl = `${config.apiUrl}/TQC1020_R01`;

export const getTQC1020_R01Header = async (params: {
    compCd?: string;
    customCd?: string;
    itemCd?: string;
    inoutClass?: string;
    startDate?: string;
    endDate?: string;
    includeCompleted?: boolean;
}) => {
    return await getData<ResponseDto<TQC1020_R01HeaderDto[]>>(`${baseUrl}/search`, { params });
};

export const getTQC1020_R01Detail = async (basOrderNo: string, basOrderItemno?: string) => {
    return await getData<ResponseDto<TQC1020_R01DetailDto[]>>(`${baseUrl}/result`, {
        params: { basOrderNo, basOrderItemno },
    });
};

export const saveTQC1020_R01 = async (dto: TQC1020_R01Dto) => {
    return await postData<TQC1020_R01Dto, ResponseDto<TQC1020_R01Dto>>(
        `${baseUrl}/save`,
        dto
    );
};

export const downloadExcel_TQC1020_R01 = async (
    params: Parameters<typeof getTQC1020_R01Header>[0]
) => getData<ResponseDto<string>>(`${baseUrl}/excel`, { params });
